import { gql } from "@apollo/client"

export const DELETE_CHILD_MUTATION = gql`mutation DeleteChild ($id: ID!) {
  deleteChild (id: $id)
}`
